var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandingEmailLogo = function SvgBrandingEmailLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 315,
    height: 408,
    viewBox: "0 0 315 408"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 42,
    x: 116,
    y: 11,
    fill: "current",
    fillRule: "evenodd",
    opacity: 1
  })));
};
export default SvgBrandingEmailLogo;